/**
 * 缓存说明:虚拟设备缓存
 */
import vm from './storeTools.js'
import deviceApi from '../components/api/deviceApi.js'
import unitStore from './unitStore.js'
import teamAssessmentApi from '../components/api/teamAssessment/teamAssessmentApi'

var basestate = {
	deviceTreeByappTypeNos: {

	},
	//可查看设备树
	readDeviceTree: undefined,
	readDeviceGroupTree: {
		//可查看设备组树
	},
	areaDeviceTreeWithTypeNos:{
		//找到区域能耗树
	},
	processTreeWithTypeNos: {
		//找到工艺树
	},
	readDeviceTreeWithTypeNos: {
		//找到含有TypeNos的设备树
	},
	controlDeviceTree: {
		//可控制设备树
	},
	unitIdToReadDevice: {
		//单位和直属的可查看虚拟设备列表
	},
	classNoToReadDevice: {
		//组编号对应的可查看虚拟设备列表
	},
	unitIdToReadAllDevice: {
		//单位对应的所有设备
	},
	unitIdToControlDevice: {
		//单位和直属的可控制虚拟设备列表
	},
	classNoToControlDevice: {
		//组编号对应的可控制虚拟设备列表
	},
	deviceNoToDevice: {
		//虚拟设备no和设备对应关系
	},
	deviceNameToUnit: {
		//设备名称对应所属单位，可能不太准确
	},
	charStationTree: //{
		//充电桩设备树
		undefined,
	//},
	readableDeviceTreeByTypeProperty: {

	},
	nowVirtualDevice: undefined,
	nowVirtualDeviceList: [],
	saveEnergyDeviceList: [],
	historShowVirtualDeviceList: [],//历史示值设备列表
	//虚拟设备no对应通讯设备列表
	virtualDeviceNoToDeviceList:{},
	demandList:[],//需量树
	energyType:[],//能耗分项
	deviceName:"",//svg图的设备名称
	logoNum:true,//logo
	customKanBanList:[],
	kanBanAppTypeGroup:[],
	kanBanEditList:[]
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		//获取能源分项
		getEnergyType(state) {
			return () => {
				if (isempty(state.energyType)) {
					store.commit("getEnergyType")
					return {}
				}
				var tree = findTreeItem([state.energyType],item => {
					return item;
				});
				return tree;
			}
		},
		//获取全部企业
		getAllUnit(state) {
			return state.readDeviceTree;
		},
		getDeviceTreeByappTypeNos(state) {
			return(appTypeNos) => {
				if(isempty(state.deviceTreeByappTypeNos[appTypeNos])) {
					store.commit("getDeviceTreeByappTypeNos",appTypeNos)
				}
				return state.deviceTreeByappTypeNos[appTypeNos]
			}
		},
		//区域能耗
		getAreaDeviceTreeWithTypeNos(state,getters) {
			return (appTypeNos,unitId) => {
				if (isempty(state.areaDeviceTreeWithTypeNos[appTypeNos])) {
					store.commit("getAreaDeviceTreeWithTypeNos", appTypeNos)
					return {}
				}
				//要到数据以后，按照单位过滤出指定树形
				if (unitId == undefined) {
					return state.areaDeviceTreeWithTypeNos[appTypeNos]
				}
				if (unitId == -1) {
					unitId = unitStore.getters.getNowUnit.id
				}
				var tree = findTreeItem([state.areaDeviceTreeWithTypeNos[appTypeNos]], item => {
					//return item.unitid == unitId
					return item.id == unitId
				})
				if (tree == undefined) {
					return {}
				}
				return tree
			}
		},
		getReadDeviceTreeWithTypeNos(state, getters) {
			return (appTypeNos, unitId) => {
				if (isempty(state.readDeviceTreeWithTypeNos[appTypeNos])) {
				
					store.commit("getReadDeviceTreeWithTypeNos", appTypeNos)
					return {}
				}
				//要到数据以后，按照单位过滤出指定树形
				if (unitId == undefined) {
					return state.readDeviceTreeWithTypeNos[appTypeNos]
				}
				if (unitId == -1) {
					unitId = unitStore.getters.getNowUnit.id
				}
				var tree = findTreeItem([state.readDeviceTreeWithTypeNos[appTypeNos]], item => {
					return item.unitid == unitId
					//return item.id == unitId
				})
				if (tree == undefined) {
					return {}
				}
				return tree
			}
		},
		getProcessTreeWithTypeNos(state,getters) {
			return (appTypeNo,unitId) => {
				if(isempty(state.processTreeWithTypeNos[appTypeNo])) {
					store.commit("getProcessTreeWithTypeNos",appTypeNo)
					return {}
				}
				//要到数据以后，按照单位过滤出指定树形
				if(unitId == undefined) {
					return state.processTreeWithTypeNos[appTypeNo]
				}
				if (unitId == -1) {
					unitId = unitStore.getters.getNowUnit.id
				}
				var tree = findTreeItem([state.processTreeWithTypeNos[appTypeNo]], item => {
					return item.unitid == unitId
				})
				if (tree == undefined) {
					return  {}
				}
				return tree
			}
		},
		getDeman(state,getters){
			return (unitId)=>{
			if(isempty(state.demandList)){
				store.commit("getDemandList")
			}else{
				var tree = findTreeItem([state.demandList], item => {
					return item.unitid == unitId
				})
				return  tree
			}
			}
		},
		getReadableDeviceTreeByTypeProperty(state, getters) {
			return type => {
				if (isempty(state.readableDeviceTreeByTypeProperty[type])) {
					store.commit("getReadableDeviceTreeByTypeProperty", type)
				}
				return state.readableDeviceTreeByTypeProperty[type]
			}
		},
		getCharStationTree(state, getters) {
			if (state.charStationTree == undefined) {
				store.commit("getCharStationTree")
				return {}
			}
			return state.charStationTree
		},
		getReadDeviceTreeByUnitId(state, getters) {
			//获取指定单位Id对应的虚拟设备树，如果传-1默认是当前可查看单位
			return unitId => {
				if (state.readDeviceTree == undefined) {
					store.commit("getReadDeviceTree")
					return {}
				}
				if (isempty(unitId)) {
					return state.readDeviceTree
				}
				if (unitId == -1) {
					unitId = unitStore.getters.getNowUnit.id
				}
				var tree = findTreeItem([state.readDeviceTree], item => {
					return item.unitid == unitId
				})
				if (tree == undefined) {
					return {}
				}
				return tree
			}
		},
		getReadDeviceTree(state, getters) {
			return getters.getReadDeviceTreeByUnitId(-1)
		},
		getControlDeviceTree(state, getters) {
			if (isempty(state.controlDeviceTree)) {
				store.commit("getControlDeviceTree")
			}
			return state.controlDeviceTree
		},
		getControlDeviceList(state,getters){
			if (isempty(getters.getControlDeviceTree)) {
				return []
			}
			return treeToList(getters.getControlDeviceTree,'next',item=>item.hasOwnProperty('next')).filter(item=>item.entityName == "VirtualDevicePojo")
		},
		getReadGroupTree(state, getters) {
			//获取过滤掉设备的可查看设备组树
			var baseTree = getters.getReadDeviceTree
			if (isempty(baseTree)) {
				return []
			}
			var copyTree = copy(baseTree)
			return filterTreeRecursive([copyTree], item => item.entityName == "AppClassType")
		},
		getReadDeviceGroupByGroupNo(state, getters) {
			return groupNo => {
				//通过groupNo查询指定的虚拟设备组
				return findTreeItem([getters.getReadDeviceTree], item => item.no == groupNo && item.entityName == "AppClassType")
			}
		},
		getReadDeviceNoList(state, getters) {
			//获取当前单位的所有设备no列表
			return treeToList(getters.getReadDeviceTree, 'next', item => {
				return item.hasOwnProperty("next")
			}).filter(item => {
				return item.entityName == "VirtualDevicePojo"
			}).map(item => item.no).sort((a, b) => a - b)
		},
		getDeviceListByVirtualDeviceNo(state,getters){
			//查询虚拟设备对应的来源通讯设备列表
			return vm.getBeanById(store,state.virtualDeviceNoToDeviceList,"getDeviceListByVirtualDeviceNo",[])
		}
	},
	mutations: {
		getEnergyType(state) {
			deviceApi.getEnergyDeviceTree(res => {
				state.energyType = res;
			})
		},
		saveDeviceName(state,name) {
				state.deviceName = name;
		},
		//设置自定义看板的设备列表
		saveDeviceList(state,list) {
			state.customKanBanList = list;
	    },
		//获取应用类型组
		saveAppTypeGroup(state,list){
			state.kanBanAppTypeGroup = list;
		},
		//需要编辑的看板实例
		saveKanBanEdit(state,list){
			state.kanBanEditList = list;
		},
		getDeviceTreeByappTypeNos(state,appTypeNos) {
			deviceApi.getDeviceTreeByappTypeNos('',appTypeNos,res => {
				vm.Vue.set(state.deviceTreeByappTypeNos,appTypeNos,res)
			})
		},
		getLogo(state,num){
			state.logoNum = num;
		},
		getAreaDeviceTreeWithTypeNos(state,appTypeNos) {
			deviceApi.getAreaDeviceTree('',appTypeNos,res => {
				vm.Vue.set(state.areaDeviceTreeWithTypeNos, appTypeNos, res)
			})
			// deviceApi.getAreaDeviceEnergy('day',36,1650249385000,1650337276000,res => {
			//
			// })
		},
		getReadDeviceTreeWithTypeNos(state, appTypeNos) {
			deviceApi.getReadDeviceTree('', appTypeNos, res => {
				// console.log("请求接口",res);
				vm.Vue.set(state.readDeviceTreeWithTypeNos, appTypeNos, res)
			}, res => {
				log(res)
			})
			// deviceApi.getAreaDeviceTree('',appTypeNos,res => {
			// 	vm.Vue.set(state.readDeviceTreeWithTypeNos, appTypeNos, res)
			// })
		},
		//获取工艺树
		getProcessTreeWithTypeNos(state,appTypeNo) {
			teamAssessmentApi.getProcessDevice(appTypeNo,res => {
				vm.Vue.set(state.processTreeWithTypeNos, appTypeNo,res)
			})
		},
		getCharStationTree(state) {
			deviceApi.getReadableDeviceTreeByArchTypeCode("ChargingPile", respon => {
				vm.Vue.set(state, "charStationTree", respon)
			})
		},
		getReadableDeviceTreeByTypeProperty(state, type) {
			deviceApi.getReadableDeviceTreeByTypeProperty(type, respon => {
				vm.Vue.set(state.readableDeviceTreeByTypeProperty, type, respon)
			})
		},
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		getReadDeviceTree(state) {
			deviceApi.getReadDeviceTree('', '', respon => {
				vm.Vue.set(state, 'readDeviceTree', respon)
				var list = treeToList(respon, 'next', item => {
					return !isempty(item.next)
				})
				list.forEach(item => {
					if (item.hasOwnProperty("next")) {
						//是组来的
						var dl = item.next.filter(i => {
							return !i.hasOwnProperty("next")
						})
						vm.Vue.set(state.classNoToReadDevice, 'no' + item.no, dl)
						if (!isempty(item.unitid)) {
							//有绑定单位的
							vm.Vue.set(state.unitIdToReadDevice, item.unitid, item)
						}
					} else {
						//设备
						vm.Vue.set(state.deviceNoToDevice, 'no' + item.no, item)
					}
				})
				if(respon.hasOwnProperty('next')) {
					respon.next.forEach(item => {
						let unitInfo = {};
					})
				}
			})
		},
		getControlDeviceTree(state) {
			deviceApi.getControlDeviceTree(respon => {
				vm.Vue.set(state, 'controlDeviceTree', respon)
				var list = treeToList(respon, 'next', item => {
					return !isempty(item.next)
				})
				list.forEach(item => {
					if (item.hasOwnProperty("next")) {
						//是组来的
						var dl = item.next.filter(i => {
							return !i.hasOwnProperty("next")
						})
						vm.Vue.set(state.classNoToControlDevice, 'no' + item.no, dl)
						if (!isempty(item.unitid)) {
							//有绑定单位的
							vm.Vue.set(state.unitIdToControlDevice, item.unitid, dl)
						}
					} else {
						//设备
						vm.Vue.set(state.deviceNoToDevice, 'no' + item.no, item)
					}
				})
			})
		},
		setNowVirtualDevice(state, device) {
			vm.Vue.set(state, 'nowVirtualDevice', device)
		},
		setNowVirtualDeviceList(state, deviceList) {
			vm.Vue.set(state, 'nowVirtualDeviceList', deviceList)
		},
		setHistorShowVirtualDeviceList(state, deviceList) {
			vm.Vue.set(state, 'historShowVirtualDeviceList', deviceList)
		},
		setSaveEnergyDeviceList(state, deviceList) {
			vm.Vue.set(state, 'saveEnergyDeviceList', deviceList)
		},
		getDeviceListByVirtualDeviceNo(state,virtualDeviceNo){
			deviceApi.findByVirtualDeviceNo(virtualDeviceNo,respon=>{
				vm.Vue.set(state.virtualDeviceNoToDeviceList,virtualDeviceNo,respon)
			})
		},
		getDemandList(state,getters){
			deviceApi.getReadDeviceTree('', "264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275", respon => {
					vm.Vue.set(state, 'demandList', respon)
			})
		}
	}
});

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */
